import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalMediaGallery = async ({ patientId, mediaType }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/get_external_media/`, {
    params: { patientId, media_type: mediaType },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data.data || [];
};

const useGetExternalMediaGallery = ({ patientId, mediaType, enabled = true }) => {
  return useQuery({
    queryKey: ["external_media_gallery", patientId, mediaType],
    queryFn: () => fetchExternalMediaGallery({ patientId, mediaType }),
    enabled: enabled && Boolean(patientId),
  });
};

export default useGetExternalMediaGallery;
